import UpdateVariant from "./UpdateVariant";

export default class UpdateService {
	id: string;
	variants: Array<UpdateVariant>;

	constructor(id?: string) {
		this.id = id;
		this.variants = new Array<UpdateVariant>();
	}
}
